import { apiGet, apiPatch } from '../standardApi';

export async function apiGetListUser (page, search) {
  const data = await apiGet(
    `user/getUserList?perPage=12&page=${page}&searchWord=${search}`
  );
  return data;
}
export async function apiResetPassword (key, code, password, oldPassword) {
  const data = await apiPatch(
    `/Users/ResetPassword/${key}/${code}`,
    JSON.stringify({
      password,
      oldPassword
    })
  );
  console.log(data);
  return data;
}
